/*
Chrome over the hero plate.

Two jobs, both cheap:

  1. Publish the masthead's real height as --masthead-h, so the hero can
     pull itself up underneath the sticky header without guessing. The
     slug row wraps at some widths, so this is measured, not assumed.

  2. Flag whether the page has scrolled away from the top. The stylesheet
     treats "not scrolled" as the unpainted state, so nothing has to be
     set before paint and there is no flash of solid chrome.
*/

const THRESHOLD = 48;

export default function heroChrome() {
    const hero = document.querySelector('.hero');
    const masthead = document.querySelector('.masthead');
    const root = document.documentElement;

    if (masthead) {
        const measure = () => {
            root.style.setProperty('--masthead-h', `${Math.round(masthead.offsetHeight)}px`);
        };
        measure();

        if ('ResizeObserver' in window) {
            new ResizeObserver(measure).observe(masthead);
        } else {
            window.addEventListener('resize', measure);
        }
    }

    if (!hero) return;

    document.body.classList.add('has-hero');

    let ticking = false;

    function sync() {
        document.body.classList.toggle('is-scrolled', window.scrollY > THRESHOLD);
        ticking = false;
    }

    window.addEventListener('scroll', () => {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(sync);
    }, { passive: true });

    // Covers a reload that restores a scroll position mid-page
    sync();
}
